import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useUserProfile } from '../hooks/useUserProfile';
import { useCanManageUsers } from '../hooks/useCanManageUsers';
import { ROUTES } from '@shared/constants/routes.constants';

interface ManageUsersGuardProps {
  children: ReactNode;
  fallback?: ReactNode;
  /** Si true, redirige a Home cuando no hay acceso (uso en rutas). */
  redirect?: boolean;
}

/**
 * Gate de UI/ruta para administración de usuarios (create:user | manage:users).
 */
export const ManageUsersGuard: React.FC<ManageUsersGuardProps> = ({
  children,
  fallback = null,
  redirect = false,
}) => {
  const { isLoading } = useUserProfile();
  const canManageUsers = useCanManageUsers();

  if (isLoading) {
    return null;
  }

  if (!canManageUsers) {
    if (redirect) {
      return <Navigate to={ROUTES.MAIN.HOME} replace />;
    }
    return <>{fallback}</>;
  }

  return <>{children}</>;
};
